import { authClient, API } from "../index";

// Count all categorias
export const countCategorias = () => {
  return authClient().get(`${API}/categoria/count`);
};

// Get all categorias
export const getCategorias = () => {
  return authClient().get(`${API}/categoria`);
};

// Get categoria by id
export const getCategoriaById = (id) => {
  return authClient().get(`${API}/categoria/${id}`);
};

// Update categoria
export const updateCategoria = (id, categoria) => {
  return authClient().put(`${API}/categoria/${id}`, categoria);
};

// Create categoria
export const postCategoria = (categoria) => {
  return authClient().post(`${API}/categoria`, categoria);
};

// Delete categoria
export const deleteCategoria = (id) => {
  return authClient().delete(`${API}/categoria/${id}`);
};

// Change status categoria
export const changeStatusCategoria = async (id, active) => {
  return authClient().put(`${API}/categoria/change-status/${id}`, { active });
};
